import * as DT from '../DataTypes';
import type * as THREE from 'three';
import { PlaneTuner } from './PlaneTuner';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class AreaMeasurementBasePlaneTuner {
  private readonly _tuner: PlaneTuner;

  protected _planningAlgorithm: PlanningAlgorithm;

  public constructor(planningAlgorithm: PlanningAlgorithm) {
    this._tuner = new PlaneTuner(planningAlgorithm);
    this._planningAlgorithm = planningAlgorithm;
  }

  private static _resolveTpName(name: string): string {
    return name.substring(0, name.length - '.area'.length);
  }

  public getValue(name: string): {
    normal: THREE.Vector3;
    origin: THREE.Vector3;
  } {
    return this._tuner.getValue(AreaMeasurementBasePlaneTuner._resolveTpName(name));
  }

  public setValueAsync(name: string, normal: THREE.Vector3, origin: THREE.Vector3): Promise<void> {
    return this._tuner.setValueAsync(AreaMeasurementBasePlaneTuner._resolveTpName(name), normal, origin);
  }

  public getShiftRange(name: string): THREE.Line3 {
    return this._tuner.getShiftRange(AreaMeasurementBasePlaneTuner._resolveTpName(name));
  }

  public getAreaMeasurement(name: string): DT.AreaMeasurement {
    return this._planningAlgorithm.getValueStrict(name, DT.AreaMeasurement);
  }
}
